import { useState } from 'react'
import { Customer, Organisation } from '../../services/api'
import { TargetPoolManager, BillingSection, UserManagement, OrganisationSettings } from '../settings'
import ProfileSettings from '../profile/ProfileSettings'

interface SettingsViewProps {
  organisation: Organisation | undefined
  customer: Customer
  user: any
  organisations: Organisation[]
}

const SettingsView: React.FC<SettingsViewProps> = ({
  organisation,
  customer,
  user,
  organisations
}) => {
  const [activeSection, setActiveSection] = useState<'profile' | 'targets' | 'billing' | 'users' | 'organisation'>('profile')
  
  // Check if user is admin
  const isAdmin = user?.isPlatformAdmin || user?.role === 'admin' || true

  return (
    <div className="flex gap-6">
      {/* Settings sidebar */}
      <div className="w-64 flex-shrink-0">
        <nav className="space-y-1">
          <button
            onClick={() => setActiveSection('profile')}
            className={`w-full text-left px-4 py-2 rounded-md transition-colors ${
              activeSection === 'profile'
                ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 font-medium'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
            }`}
          >
            My Profile
          </button>
          
          <button
            onClick={() => setActiveSection('targets')}
            className={`w-full text-left px-4 py-2 rounded-md transition-colors ${
              activeSection === 'targets'
                ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 font-medium'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
            }`}
          >
            Target Pool
          </button>
          
          {isAdmin && (
            <>
              <button
                onClick={() => setActiveSection('billing')}
                className={`w-full text-left px-4 py-2 rounded-md transition-colors ${
                  activeSection === 'billing'
                    ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 font-medium'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                }`}
              >
                Billing & Subscription
              </button>
              
              <button
                onClick={() => setActiveSection('users')}
                className={`w-full text-left px-4 py-2 rounded-md transition-colors ${
                  activeSection === 'users'
                    ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 font-medium'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                }`}
              >
                Users & Permissions
              </button>
            </>
          )}
          
          <button
            onClick={() => setActiveSection('organisation')}
            className={`w-full text-left px-4 py-2 rounded-md transition-colors ${
              activeSection === 'organisation'
                ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 font-medium'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
            }`}
          >
            Organisation
          </button>
        </nav>
      </div>

      {/* Settings content */}
      <div className="flex-1">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          {activeSection === 'profile' && (
            <ProfileSettings user={user} />
          )}
          
          {activeSection === 'targets' && organisation && (
            <TargetPoolManager organisation={organisation} />
          )}
          
          {activeSection === 'billing' && (
            <BillingSection customer={customer} />
          )}
          
          {activeSection === 'users' && (
            <UserManagement customer={customer} />
          )}
          
          {activeSection === 'organisation' && organisation && (
            <OrganisationSettings organisation={organisation} />
          )}
          
          {!organisation && activeSection !== 'billing' && activeSection !== 'users' && (
            <div className="text-center py-12">
              <p className="text-gray-500 dark:text-gray-400">Please select an organisation</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SettingsView
